/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Form, Field } from 'react-final-form';
import { useNavigate } from 'react-router-dom';
import { TextField, Button } from '@mui/material';
import { ApiClient } from '../helpers/apiClient';
import { useMsal } from '@azure/msal-react';
import { useEventContext } from '../contexts/EventContext';

interface FormValues {
  name: string;
  email: string;
  faculty: string;
}

const required = (value: any) => (value ? undefined : 'Required');

const AddParticipant: React.FC = () => {
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();

  const {
    selectedEventId,          // uid for the dropdown
    selectedApiEventId,       // real eventID for server calls
    events,
  } = useEventContext();

  const createParticipant = async (values: FormValues) => {
    const apiClient = ApiClient.getInstance(instance, accounts[0], {
      baseUrl: process.env.REACT_APP_API_BASE_URL,
    });

    if (!selectedApiEventId) {
      alert('No event selected');
      return;
    }

    const currentEvent = events.find((e) => e.id === selectedEventId);
    const body = {
      eventID: selectedApiEventId,        
      locationID: currentEvent?.locationId ?? null, 
      fullName: values.name,
      email: values.email,
      faculty: values.faculty,
    };

    await apiClient?.post('Participant/Add', JSON.stringify(body));
  };

  const handleSave = async (
    values: any,
    form: any,
    navigateBack?: boolean,
  ) => {
    try {
      await createParticipant(values);
      if (navigateBack) {
        navigate('/dashboard');
      } else {
        form.reset();
      }
    } catch (err) {
      console.error('Error saving participant:', err);
    }
  };

  return (
    <div style={{ maxWidth: '600px', margin: '0 auto', padding: '1rem' }}>
      <h2>New participant</h2>
      <Form
        onSubmit={() => {}}
        initialValues={{ name: '', email: '' }}
        render={({ form, submitting, values, handleSubmit }) => (
          <form onSubmit={handleSubmit} noValidate>
            <Field<string> name="name" validate={required}>
              {({ input, meta }) => (
                <div style={{ marginBottom: '1rem' }}>
                  <label style={{ display: 'block', marginBottom: '0.5rem' }}>
                    Name
                  </label>
                  <TextField
                    {...input}
                    placeholder="Add a name"
                    variant="outlined"
                    size="small"
                    fullWidth
                    error={meta.touched && meta.error !== undefined}
                    helperText={meta.touched && meta.error}
                  />
                </div>
              )}
            </Field>

            <Field<string> name="email" validate={required}>
              {({ input, meta }) => (
                <div style={{ marginBottom: '1rem' }}>
                  <label style={{ display: 'block', marginBottom: '0.5rem' }}>
                    Email
                  </label>
                  <TextField
                    {...input}
                    placeholder="Add an email"
                    variant="outlined"
                    size="small"
                    fullWidth
                    error={meta.touched && meta.error !== undefined}
                    helperText={meta.touched && meta.error}
                  />
                </div>
              )}
            </Field>

            <Field<string> name="faculty">
              {({ input }) => (
                <div style={{ marginBottom: '1rem' }}>
                  <label style={{ display: 'block', marginBottom: '0.5rem' }}>
                    Faculty
                  </label>
                  <TextField
                    {...input}
                    placeholder="Add a faculty"
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </div>
              )}
            </Field>

            <div style={{ display: 'flex', gap: '0.5rem', marginTop: '2rem' }}>
              <Button variant="outlined" onClick={() => navigate(-1)}>
                Back
              </Button>

              <Button variant="outlined" onClick={() => navigate('/dashboard')}>
                Cancel
              </Button>

              <Button
                variant="contained"
                color="success"
                onClick={() => handleSave(values, form, true)}
                disabled={submitting}
              >
                Save
              </Button>

              <Button
                variant="contained"
                color="success"
                onClick={() => handleSave(values, form, false)}
                disabled={submitting}
              >
                Save and add new
              </Button>
            </div>
          </form>
        )}
      />
    </div>
  );
};

export default AddParticipant;
